<template>
  <v-container fluid grid-list-md>
    <v-layout row wrap justify-center align-center>
      <v-flex xs12 sm12 md10 lg10>
        <v-card>
          <card-toolbar title="Ayarlar"></card-toolbar>
          <v-tabs :vertical="$vuetify.breakpoint.mdAndUp" centered>
            <v-tab @click="loadAccountSettings">
              <v-icon left>mdi-account</v-icon>
              Hesap Ayarları
            </v-tab>
            <v-tab>
              <v-icon left>mdi-lock</v-icon>
              SMS Ayarları
            </v-tab>
            <v-tab @click="listNumbers">
              <v-icon left>mdi-phone</v-icon>
              Doğrulama Numaraları
            </v-tab>

            <v-tab-item>
              <v-card flat>
                <v-card-text>
                  <v-layout row>
                    <v-list three-line>
                      <v-list-item>
                        <v-list-item-avatar>
                          <v-avatar color="orange lighten-4" size="48">
                            <span class="font-weight-light headline">
                              {{ user.settings.name.charAt(0).toUpperCase() }}
                              {{
            user.settings.surname.charAt(0).toUpperCase()
          }}
                            </span>
                          </v-avatar>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title class="title">
                            {{ user.settings.name }} {{ user.settings.surname }}
                          </v-list-item-title>
                          <v-list-item-subtitle v-text="user.settings.email">
                          </v-list-item-subtitle>
                          <span class="
                              v-list-item__subtitle
                              mt-1
                              mr-1
                              text--accent-2
                              fit-content
                            ">
                            Güncel Kredi
                          </span>
                          <v-list-item-title class="fit-content">
                            {{ user.settings.credit }}
                          </v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                          <pluggable-as-dialog max-width="800" @click:outside="resetShowAPIDialog">
                            <template v-slot:activator="{ on }">
                              <v-btn text v-on="on">
                                api bilgilerimi görüntüle
                              </v-btn>
                            </template>

                            <template v-slot:content>
                              <v-container fluid grid-list-md>
                                <v-tabs-items v-model="api.tab">
                                  <v-tab-item>
                                    <v-layout row>
                                      <v-flex xs12>
                                        <v-label>Lütfen Güncel Şifrenizi Giriniz...
                                        </v-label>
                                        <v-text-field v-model="api.current_password" @keydown.enter="showAPIDialog"
                                          type="password" label="Şifre">
                                        </v-text-field>
                                      </v-flex>
                                      <v-flex xs12>
                                        <div class="text-center">
                                          <v-btn color="primary" @click.stop="showAPIDialog">
                                            Görüntüle
                                          </v-btn>
                                        </div>
                                      </v-flex>
                                    </v-layout>
                                  </v-tab-item>
                                  <v-tab-item>
                                    <v-layout row>
                                      <v-flex xs12>
                                        <v-text-field label="SMS API Kullanıcı ID" :value="api.oztek_id" disabled>
                                        </v-text-field>
                                        <v-text-field label="SMS API Kullanıcı Adı" :value="api.username" disabled>
                                        </v-text-field>
                                        <v-text-field label="SMS API Şifre" :value="api.password" disabled>
                                        </v-text-field>

                                      </v-flex>

                                      <!-- <v-flex xs12>
                                        <v-text-field label="Whatsapp API Client Secret" :value="api.wp_client_secret"
                                          disabled>
                                        </v-text-field>
                                        <v-text-field label="Whatsapp API Client ID" :value="api.wp_client_id" disabled>
                                        </v-text-field>

                                      </v-flex> -->
                                      <v-btn depressed @click="resetShowAPIDialog">
                                        Kapat
                                      </v-btn>
                                    </v-layout>


                                  </v-tab-item>
                                </v-tabs-items>
                              </v-container>
                            </template>
                          </pluggable-as-dialog>
                        </v-list-item-action>
                      </v-list-item>
                    </v-list>
                  </v-layout>
                  <v-divider class="mb-4"></v-divider>
                  <span class="subtitle-1 font-weight-black">Kullanıcı Bilgileri</span>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-form ref="usForm" lazy-validation>
                        <v-layout row>
                          <v-flex xs12 md12>
                            <v-text-field label="Firma Adı" v-model="user.settings.company_name"
                              :disabled="user.settings.confirmation === '1'">
                            </v-text-field>
                          </v-flex>
                          <v-flex xs12 md4>
                            <v-text-field maxlength="11" minlength="11" :disabled="!!originalIdNumber"
                              :rules="[tcKimlikRule]" label="TC Kimlik Numarası" counter="11"
                              v-model="user.settings.identity">
                              <template v-slot:append>
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon v-bind="attrs" v-on="on" small>mdi-information-outline</v-icon>
                                  </template>
                                  <span>SMS gönderiminde E-İmza doğrulaması için gereklidir</span>
                                </v-tooltip>
                              </template>
                            </v-text-field>
                          </v-flex>
                          <v-flex xs12 md4>
                            <v-text-field v-mask="'##/##/####'" :rules="[
            $rules.empty(
              'Doğum Tarihi (Format:10/04/1990)'
            ),
          ]" :disabled="user.settings.confirmation === '1'" label="Doğum Tarihi"
                              v-model="user.settings.birth_day">
                            </v-text-field>
                          </v-flex>
                          <v-flex xs12 md6>
                            <v-text-field label="Ad" :rules="[$rules.empty('Ad')]"
                              :disabled="user.settings.confirmation === '1'" v-model="user.settings.name">
                            </v-text-field>
                          </v-flex>
                          <v-flex xs12 md6>
                            <v-text-field label="Soyad" :rules="[$rules.empty('Soyad')]"
                              :disabled="user.settings.confirmation === '1'" v-model="user.settings.surname">
                            </v-text-field>
                          </v-flex>
                          <v-flex xs12 md6>
                            <v-text-field label="E-mail" :rules="[$rules.empty('Email')]"
                              :disabled="user.settings.confirmation === '1'" v-model="user.settings.email">
                            </v-text-field>
                          </v-flex>
                          <v-flex xs12 md6>
                            <v-text-field disabled v-mask="'0(###) ### ## ##'"
                              :rules="[$rules.empty('Telefon Numarası')]" label="Telefon Numarası"
                              v-model="user.settings.phone">
                            </v-text-field>
                          </v-flex>
                          <v-flex xs12 md6>
                            <v-text-field label="İl" v-model="user.settings.city"
                              :disabled="user.settings.confirmation === '1'">
                            </v-text-field>
                          </v-flex>
                          <v-flex xs12 md6>
                            <v-text-field label="İlçe" v-model="user.settings.district"
                              :disabled="user.settings.confirmation === '1'">
                            </v-text-field>
                          </v-flex>
                          <v-flex xs12>
                            <v-textarea outlined label="Adres" v-model="user.settings.address"
                              :disabled="user.settings.confirmation === '0'">
                            </v-textarea>
                          </v-flex>
                          <v-btn class="mb-4" @click="saveProfileSettings">
                            Kullanıcı Bilgilerini Güncelle
                          </v-btn>
                        </v-layout>
                      </v-form>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <span class="subtitle-1 font-weight-black">Şifre İşlemleri</span>
                    <v-flex xs12>
                      <v-form ref="pwForm" lazy-validation>
                        <v-layout row>
                          <v-flex xs12 md12>
                            <v-text-field :rules="[$rules.empty('Kullanıcı Adı')]" label="Kullanıcı Adı"
                              v-model="user.credentials.username">
                            </v-text-field>
                          </v-flex>
                          <v-flex xs12 md12>
                            <v-text-field v-model="user.credentials.old_password" type="password" required
                              label="Güncel Şifreniz">
                            </v-text-field>
                          </v-flex>
                          <v-flex xs12 md12>
                            <v-text-field v-model="user.credentials.new_password" type="password" required
                              label="Yeni Şifreniz">
                            </v-text-field>
                          </v-flex>
                          <v-flex xs12 md12>
                            <v-text-field v-model="user.credentials.new_password_again" :rules="confirmPassword"
                              required type="password" label="Yeni Şifreniz Tekrar">
                            </v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-form>
                    </v-flex>
                  </v-layout>
                  <v-spacer></v-spacer>
                  <div class="text-xs-right">
                    <v-btn @click="saveCredentials">Kaydet</v-btn>
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>

            <v-tab-item>
              <v-card flat>
                <v-card-text>
                  <v-form>
                    <v-layout wrap>
                      <v-flex xs12 sm12 md6 lg6 v-for="(item, i) in data.customs" :key="i">
                        <v-text-field v-model="data.customs[i].val.value" :label="item.val.alias"
                          :value="item.val.value">
                        </v-text-field>
                      </v-flex>
                      <v-flex xs12 sm12 md6 lg6>
                        <v-flex xs12 sm12 md6 lg6>
                          <v-select :items="user.senders" label="Varsayılan Gönderici Adı"
                            v-model="data.settings.default_sender"  item-text="name" item-value="id"></v-select>
                        </v-flex>
                      </v-flex>
                      <v-flex xs12 sm12 md6 lg6>
                        <v-flex xs12 sm12 md6 lg6>
                          <v-select :items="types" label="Varsayılan Mesaj Tipi"
                            v-model="data.settings.default_message_type"></v-select>
                        </v-flex>
                      </v-flex>
                      <v-flex xs12 sm12 md6 lg6>
                        <v-flex xs12 sm12 md12 lg12>
                          <v-select :items="brandCodes" label="Varsayılan İYS Markası" v-model="iys_default_brand_code"
                            item-text="name" item-value="value"></v-select>
                        </v-flex>
                      </v-flex>
                    </v-layout>
                    <v-spacer></v-spacer>
                    <v-layout row align-center md12>
                      <v-flex xs12 sm12 md6 lg6>
                        <h2>Okundu Bilgisi:</h2>
                      </v-flex>
                      <v-flex xs12 sm12 md6 lg6>
                        <h4 v-if="!readInfoStatus" class="text-black">
                          Linkiniz aktif değil, aktivasyon için müşteri
                          temsilcinizle iletişime geçiniz.
                        </h4>
                        <div v-else>
                          <v-select :items="readData.data" label="Okundu Durumu" v-model="readData.status"
                            @change="handleReadStatus" item-text="name" item-value="value"></v-select>
                          <v-select v-if="readData.status" :items="readData.selects" label="Seçim"
                            v-model="readData.selected" @change="handleReadSelected" item-text="name"
                            item-value="value"></v-select>
                          <v-textarea v-if="readData.status" @change="handleReadMessage" placeholder="Mesajınız"
                            :value="this.readData.message"></v-textarea>
                        </div>
                      </v-flex>
                    </v-layout>
                    <v-spacer></v-spacer>
                    <div class="text-xs-right">
                      <v-btn @click="saveSettings">Kaydet</v-btn>
                    </div>
                  </v-form>
                </v-card-text>
              </v-card>
            </v-tab-item>

            <v-tab-item>
              <v-row class="rows">
                <v-col cols="12">
                  <v-alert type="warning" border="left" colored-border elevation="2" class="mb-3">
                    <strong>01.04.2026</strong> itibarıyla SMS gönderim arayüzlerine erişim yalnızca aboneliğin yetkilisi veya SMS göndermeye yetkili kişi tarafından <strong>e-İmza</strong> ile yapılabilecektir.
                    SMS gönderim yetkisi olan Kullanıcılar için <strong>TC Kimlik Numarası</strong> alanlarının da doldurulması gerekir.
                  </v-alert>
                </v-col>
                <v-col cols="12">
                  <v-alert type="info">
                    Giriş sağlarken iki adımlı doğrulama yapmak için
                    kullanılabilecek numaraları aşağıda listeleyebilirsiniz.
                  </v-alert>
                </v-col>
                <v-col cols="12" sm="6" md="8">
                  <v-data-table v-model="selected" :headers="headers" :items="items" show-expand item-key="id"
                    class="elevation-1" hide-default-footer>
                    <template v-slot:expanded-item="{ item, headers }">
                      <td :colspan="headers.length">
                        <v-card-text>
                          <v-form>
                            <v-layout>
                              <v-text-field v-model="item.name" :counter="10" label="Ad" prepend-inner-icon="person"
                                required></v-text-field>
                            </v-layout>

                            <v-layout>
                              <v-text-field v-model="item.phone" :rules="[$rules.empty('Telefon Numarası')]"
                                prepend-inner-icon="phone" required label="Telefon Numarası"
                                v-mask="'0(###) ### ## ##'">
                                >
                              </v-text-field>
                            </v-layout>
                            <v-layout>
                              <v-text-field
                                v-model="item.identity"
                                label="TC Kimlik Numarası"
                                prepend-inner-icon="mdi-card-account-details-outline"
                                :disabled="!!item._originalIdentity"
                                :rules="[tcKimlikRule]"
                                maxlength="11"
                                counter="11"
                              >
                                <template v-slot:append>
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-icon v-bind="attrs" v-on="on" small>mdi-information-outline</v-icon>
                                    </template>
                                    <span>SMS gönderiminde E-İmza doğrulaması için gereklidir</span>
                                  </v-tooltip>
                                </template>
                              </v-text-field>
                            </v-layout>
                            <v-spacer></v-spacer>
                            <div class="text-xs-right">
                              <v-btn @click="updateOtherNumber(item)">Güncelle</v-btn>
                              <v-btn class="ml-3" @click="deleteOtherNumber(item)">sil</v-btn>
                            </div>
                          </v-form>
                        </v-card-text>
                      </td>
                    </template>
                  </v-data-table>
                  <pagination :pagination="pagination" :action="onPagination">
                  </pagination>
                </v-col>

                <v-col cols="6" md="4" class="pr-5">
                  <span class="subtitle-1 font-weight-black">Yeni Numara</span>
                  <v-form>
                    <v-layout wrap>
                      <v-text-field v-model="newNumber.phone" label="Telefon numarası" prepend-inner-icon="phone"
                        v-mask="'0(###) ### ## ##'">
                        required >
                      </v-text-field>
                      <v-text-field v-model="newNumber.name" prepend-inner-icon="person" label="Ad"
                        required></v-text-field>
                      <v-text-field
                        v-model="newNumber.identity"
                        label="TC Kimlik Numarası"
                        prepend-inner-icon="mdi-card-account-details-outline"
                        :rules="[tcKimlikRule]"
                        maxlength="11"
                        counter="11"
                      >
                        <template v-slot:append>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-bind="attrs" v-on="on" small>mdi-information-outline</v-icon>
                            </template>
                            <span>SMS gönderiminde E-İmza doğrulaması için gereklidir</span>
                          </v-tooltip>
                        </template>
                      </v-text-field>
                    </v-layout>
                    <sms-verification :phone="newNumber.phone" @emitVerification="emitVerification" />

                    <v-spacer></v-spacer>
                    <div class="text-xs-right">
                      <v-btn @click="saveNewNumber">Ekle</v-btn>
                    </div>
                  </v-form>
                </v-col>
              </v-row>
            </v-tab-item>
          </v-tabs>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import CardToolbar from "../../Components/CardToolbar.vue";
import { types } from "../../../misc";
import PluggableAsDialog from "../../Components/Pluggable/PluggableAsDialog.vue";
import SmsVerification from "@/views/Components/SmsVerification";

export default {
  name: "Index",
  components: { SmsVerification, PluggableAsDialog, CardToolbar },
  data: (vm) => ({
    newNumber: { name: null, phone: null, key: null, hash: null, identity: null },
    items: [],
    headers: [
      {
        text: "Adı",
        align: "start",
        sortable: false,
        value: "name",
      },
      { text: "Telefon", value: "phone" },
      { text: "TC Kimlik No", value: "identity" },
    ],
    types,
    api: {
      tab: 0,
      current_password: "",
    },
    user: {
      credentials: {
        username: "",
        old_password: "",
        new_password: "",
        new_password_again: "",
      },
      settings: {
        name: "",
        surname: "",
      },
      senders: [],
      message_types: ["normal", "turkce"],
    },
    originalIdNumber: null,
    accountDetails: {},
    data: {
      settings: {},
      customs: [],
    },
    postData: {},
    confirmPassword: [
      (val) =>
        val === vm.user.credentials.new_password ||
        "Girdiğiniz şifreler birbiriyle uyuşmuyor." ||
        this.$refs.pwForm.reset(),
    ],
    brandCodes: [],
    iys_default_brand_code: null,
    readInfoStatus: 0,
    readData: {
      status: 1,
      message: "Mesajı okuduğunuza dair onay için linke tıklayınız",
      selected: 1,
      data: [
        { name: "Aktif", value: 1 },
        { name: "Pasif", value: 0 },
      ],
      selects: [
        { name: "Seçili Gelsin", value: 1 },
        { name: "Seçili Gelmesin", value: 0 },
      ],
    },
  }),
  methods: {
    ...mapActions({ send: "sendBackend" }),
    handleReadStatus(val) {
      this.readData.status = val;
    },
    handleReadSelected(val) {
      this.readData.selected = val;
    },
    handleReadMessage(val) {
      this.readData.message = val;
    },
    loadAccountSettings() {
      this.send({ route: "me" }).then((res) => {
        this.user.settings = res.data.data.user;
        this.originalIdNumber = this.user.settings.identity || null;
        this.user.credentials.username = this.user.settings.username;
        this.accountDetails = res.data.data.accountDetails;
      });
    },
    getBrandCodes() {
      this.send({ route: "iys/detail" }).then((response) => {
        this.brandCodes = [
          ...response.data.data.data.map((brand) => ({
            name: `${brand.brandCode} - ${brand.name}`,
            value: brand.brandCode,
          })),
        ];
      });
    },
    saveProfileSettings() {
      this.send({
        route: "identity/update",
        data: { identity: this.user.settings.identity },
      });
    },
    saveCredentials() {
      this.send({
        route: "change/credentials",
        data: this.user.credentials,
      }).then(() => {
        this.user.credentials.old_password = "";
        this.user.credentials.new_password = "";
        this.user.credentials.new_password_again = "";
      });
    },
    saveSettings() {
      const replicated = this.data.customs;

      Object.entries(replicated).forEach((el) => {
        if (el[0].includes("custom_field")) {
          delete replicated[el[0]];
        }
      });

      this.postData = {
        ...this.normalizedCustoms(),
        read_message: this.readData.message,
        read_status: this.readData.status,
        read_selected: this.readData.selected,
      };
      this.postData.default_sender = this.data.settings.default_sender;
      this.postData.default_message_type =
        this.data.settings.default_message_type === "normal" ? 1 : 2;
      this.postData.iys_default_brand_code = this.iys_default_brand_code;
      this.send({
        route: "update/settings",
        data: this.postData,
      });
    },
    normalizedCustoms() {
      const d = {};
      this.data.customs.forEach((el) => {
        d[el.key] =
          el.val.value === null ? el.val.value : el.val.value.toString();
      });

      return d;
    },
    showAPIDialog() {
      this.send({
        route: "show/api/credentials",
        data: {
          password: this.api.current_password,
        },
      }).then((res) => {
        this.api = { ...res.data.data };
        this.api.tab = 1;
      });
    },
    resetShowAPIDialog() {
      this.api.tab = 0;
      this.api.username = "";
      this.api.password = "";
      this.api.wp_client_secret = "";
      this.api.wp_client_id = "";
      this.$trigger("setPluginDialog");
    },
    saveNewNumber() {
      this.send({ route: "add/tsa/number", data: this.newNumber }).then(
        () => {
          this.newNumber = { name: null, phone: null, key: null, hash: null, identity: null };
          this.listNumbers();
        }
      );
    },
    emitVerification(data) {
      this.newNumber = {
        ...this.newNumber,
        ...data,
      };
    },
    tcKimlikRule(val) {
      if (!val || val.length === 0) return true;
      if (val.length !== 11 || !/^\d{11}$/.test(val)) return 'Geçersiz TC Kimlik Numarası';
      if (val[0] === '0') return 'Geçersiz TC Kimlik Numarası';
      const d = val.split('').map(Number);
      const sumOdd = d[0] + d[2] + d[4] + d[6] + d[8];
      const sumEven = d[1] + d[3] + d[5] + d[7];
      if (d[9] !== (sumOdd * 7 - sumEven) % 10) return 'Geçersiz TC Kimlik Numarası';
      if (d[10] !== (d[0]+d[1]+d[2]+d[3]+d[4]+d[5]+d[6]+d[7]+d[8]+d[9]) % 10) return 'Geçersiz TC Kimlik Numarası';
      return true;
    },
    listNumbers() {
      this.send({ route: "show/tsa/numbers" }).then((res) => {
        this.items = res.data.data.map((item) => ({
          ...item,
          _originalIdentity: item.identity || null,
        }));
      });
    },
    updateOtherNumber(item) {
      this.send({
        route: "update/tsa/number",
        data: { id: item.id, name: item.name, phone: item.phone, identity: item.identity },
      }).then(() => {
        this.listNumbers();
      });
    },
    deleteOtherNumber(item) {
      this.send({ route: "delete/tsa/number", data: { id: item.id } }).then(
        () => {
          this.listNumbers();
        }
      );
    },
  },
  created() {
    this.send({ route: "show/settings" }).then(async (res) => {
      this.data.settings = await res.data.data.settings;
      if(res.data.data.read !== undefined){
        this.readInfoStatus = res.data.data.read.read_info_status
        this.readData = {
          ...this.readData,
          message: res.data.data.read.read_message,
          selected: res.data.data.read.read_selected,
          status: res.data.data.read.read_status,
        };
      }
      this.user.senders = res.data.data.senders;
      this.iys_default_brand_code = this.data.settings.iys_default_brand_code;

      Object.entries(this.data.settings).forEach((el) => {
        if (el[0].includes("custom_field")) {
          this.data.customs.push({
            key: el[0],
            val: el[1],
          });
        }
      });

      ["id", "user_id", "default_message_type"].map(
        (el) => delete this.data[el]
      );
    });

    this.loadAccountSettings();
    this.getBrandCodes();
  },
};
</script>

<style scoped>
.fit-content {
  max-width: fit-content;
}

.rows {
  padding: 20px 10px;
}

v-col {
  border: none !important;
}

.v-tab {
  width: 100%;
  justify-content: flex-start;
}
</style>